import { AppServices } from '@singularsystems/neo-core';

import TermsAndConditionsService from './Services/TermsAndConditionsService';

// Symbols to expose outside of this module
const CommonIdentitySharedTypes = {   
    Services: {
        TermsAndConditionsService: new AppServices.ServiceIdentifier<TermsAndConditionsService>("Identity.Services.TermsAndConditionsService"),
    },
}

export { CommonIdentitySharedTypes }